module.exports = "# Esmeralda and Goober Story\n\nYouTube: Ka3bcyUj6TU\n\n## Notes\nEsmeralda and Goober storyline wrap-up (2:19).\n"


//////////////////
// WEBPACK FOOTER
// ./programs/epsPrimaries/sections/11_esGooberStory/level4_egstory.md
// module id = 1634
// module chunks = 2